// The pager under a paged list (All candidates, the job list). Pure, so the edges (an empty
// list, a short last page, a long run of pages) are tested.

export function pageCountOf(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

/** "Showing 51–100 of 1,284" as numbers; 0–0 for an empty list. */
export function shownRange(page: number, pageSize: number, rowCount: number): { readonly from: number; readonly to: number } {
  if (rowCount === 0) return { from: 0, to: 0 };
  const from = (page - 1) * pageSize + 1;
  return { from, to: from + rowCount - 1 };
}

/** How many pages either side of the current one the pager shows before an ellipsis. */
const PAGER_REACH = 1;

/** The pager's buttons: 1 2 3 … 52, with the current page and its neighbours always shown. */
export function pagerItems(current: number, pageCount: number): readonly (number | 'gap')[] {
  const items: (number | 'gap')[] = [];
  for (let page = 1; page <= pageCount; page += 1) {
    const isEdge = page === 1 || page === pageCount;
    const isNear = Math.abs(page - current) <= PAGER_REACH || (current <= 2 && page <= 3) || (current >= pageCount - 1 && page >= pageCount - 2);
    if (isEdge || isNear) items.push(page);
    else if (items.at(-1) !== 'gap') items.push('gap');
  }
  return items;
}
